module.exports = __webpack_public_path__ + "media/student_v2/assets/images/comment-8e42b630878e4a456b7d641ee9308325.svg";